import { plusIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Plus = createIcon({
  displayName: 'Plus',
  paths: [
    'M512 170.667c-23.552 0-42.667 19.115-42.667 42.667v256h-256c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h256v256c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-256h256c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-256v-256c0-23.552-19.115-42.667-42.667-42.667z'
  ],
  canvasPaths: canvasIconPaths(plusIcon)
})
